/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ProviderAccountIdFilters {
  /**
  * Matches if any value in this list equals `providerAccountId`.
  */
  '_in'?: Array<string>;
  /**
  * Matches if none of the values in this list equal `providerAccountId`.
  */
  'notIn'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "_in",
      "baseName": "in",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "notIn",
      "baseName": "notIn",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ProviderAccountIdFilters.attributeTypeMap;
  }

  public constructor() {
  }
}

